import styled from 'styled-components';
import { Alert } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const StyledAlert = styled(Alert)`
  height: 100%;
  justify-content: center;
  align-items: center;
`;
